import React from 'react';
import './AIBadge.css';

// Small "AI" pill shown beside an AI persona's name so AI participants are
// unmistakable wherever they appear — messages, the sidebar, @mentions.
function AIBadge() {
  return (
    <span className="ai-badge" title="AI participant">
      AI
    </span>
  );
}

export default AIBadge;
